import { HelpRounded } from "@material-ui/icons";
import styled from "styled-components";
// import HelpCenterIcon from '@mui/icons-material/HelpCenter';




const Styles = styled.div`
  position: relative;
  display: block;
  height: fit-content;
  .icon {
    position: relative;
  }
  .text {
    width: 17rem;
    text-align: center;
    border-radius: 6px;
    position: absolute;
    background: #fcfcfc;
    font-size: 0.75rem;
    padding: 0.5rem;
    z-index: 1;
    border: none;
    display: none !important;
    box-shadow: 0 2px 4px #00000028;
  }

  .icon:hover + .text {
    display: block !important;
    position: absolute;
    bottom: 2.5rem;
    right: -50%;
    display: flex;
    align-items: center;
  }
`;
const Span = styled.span`
  position: relative;
  display: block;
  border-bottom: 1px dotted black;
  margin: auto;
  ::before {
    bottom: -5px;
    content: "";
    position: absolute;
    transform: rotate(45deg);
    background: #fcfcfc;
    z-index: 1;
    right: 50%;
    border-radius: 2px;
    width: 0.625rem;
    height: 0.625rem;
    box-shadow: 3px 3px 2.7px -1.5px #00000028;
  }
`;
export const Tooltip = ({ ClassTooltip, children, ClassText, style, width, right }) => {
  return (
    <Styles style={style} className={ClassTooltip}>
      <HelpRounded className="icon" style={{fontSize: "20px"}}/>
      <Span className={"text " + ClassText} style={{width: width, right: right}}>{children}</Span>
    </Styles>
  );
};
